import ListView from '../framework/ListView';
import BaseView from './BaseView';

/**
 * See {@link src/framework/ListView} for more detail and examples from the base class.
 * @class module:Okta.ListView
 * @extends src/framework/ListView
 * @mixes module:Okta.View
 */
export default BaseView.decorate(ListView);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/courage/src/views/Backbone.ListView.js
// module id = 54
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/views/Backbone.ListView.js